import { SiteConfig } from "../../types";

export const _config: SiteConfig = {
  isDefault: true,
  enableStripeBilling: true,
  serviceName: "Talkio AI",
  publicUrl: "https://www.talkio.ai",
  appLogoPath: "/talkio-logo-white.svg",
  appLogoHeight: "22px",
  landingLogoPath: "/talkio-logo.svg",
  landingLogoHeight: "25px",
  favicon: "/favicon.png",
  adminEmail: "hello@talkio.ai",
  emailsSender: "hello@talkio.ai",
  copyright: "Aidia ApS",
  reviewLink: "https://senja.io/p/talkio/r/9XyUN8",
  showTidio: true,
  showLanguageGuides: true,
  hideNavigation: true,
  isMobileApp: "true",
};
